// tslint:disable
/**
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
export var MedicalEligibilityGender;
(function (MedicalEligibilityGender) {
    MedicalEligibilityGender["Male"] = "M";
    MedicalEligibilityGender["Female"] = "F";
    MedicalEligibilityGender["Unknown"] = "U";
})(MedicalEligibilityGender || (MedicalEligibilityGender = {}));
//# sourceMappingURL=medicalEligibilityGender.js.map